export interface PromoInfo {
  free_bets?: FreeBet[];
  tournament?: Tournament;
  tournament_reward?: TournamentReward;
}

export enum PromoType {
  F_B,
  T,
}

export interface PromoRule {
  type: PromoType;
  payload: unknown;
}

export interface FreeBet {
  id: string;
  amount: string;
  active: boolean;
  existed: boolean;
  available_to?: string;
  used_rounds: number;
  assigned_rounds: number;
  available_rounds: number;
}

export enum FreeBetStatus {
  A = "active",
  I_A = "inactive",
}

export interface FreeBetState {
  status: FreeBetStatus;
  disabled: boolean;
  freeBet: FreeBet;
}

export interface Tournament extends TournamentPlayerInfo {
  status: TournamentStatus;
  finish_at: string;
  close_at: string;
  start_at: string;
  scoring_method: TournamentScoringMethod;
  scoring_rule_multiplier?: number;
  bet_multiplier?: number;
  win_multiplier?: number;
  id: number;
  min_bet?: string;
  min_bet_count?: number;
  prizes: TournamentPrize[];
  total_bet?: string;
  total_win?: string;
}

export enum TournamentScoringMethod {
  W = "WIN_MULTIPLIER_POINTS",
  B = "BET_WIN_POINTS",
}

export interface TournamentPlayerInfo {
  player_rank: number;
  player_score: number;
}

export enum TournamentStatus {
  D = "DRAFT",
  A = "ACTIVE",
  P = "PAUSED",
  F = "FINISHED",
  CG = "CLOSING",
  CD = "CLOSED",
}

export interface TournamentRecord {
  is_current_player: boolean;
  rank: number;
  score: number;
  username: string;
  win_amount: string;
}

export interface TournamentPrize {
  amount: string;
  place_to: number;
  place_from: number;
}

export interface TournamentReward {
  id: string;
  amount: string;
  player_rank: number;
  player_score: number;
  expired_at: string;
  is_claimed: boolean;
}
